// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wqCr","right":"styles_right__1rVdr"};